import { useRef } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import cn from 'classnames';

import { createHeartList } from 'actions/hearts';

import modalCSS from 'styles/components/common/modal.scss';
import css from 'styles/components/account/collectionModals/newCollectionModal.scss';

export const NewCollectionModal = ({
  onDoneModal,
  showNewCollectionModal,
  onCancelModal,
  createHeartList
}) => {
  const input = useRef();

  const onSaveNewCollection = e => {
    e.preventDefault();
    const { collectionName: { value } } = e.currentTarget;
    createHeartList({ listName: value }).then(onDoneModal);
  };

  const onAfterOpen = () => {
    input.current?.focus();
  };

  return (
    <Modal
      className={cn(modalCSS.modalContent, css.modal)}
      overlayClassName={modalCSS.modalOverlay}
      bodyOpenClassName={css.modalOpenBodyStyle}
      onAfterOpen={onAfterOpen}
      isOpen={showNewCollectionModal}>
      <div>
        <div className={cn(modalCSS.header, css.header)}>
          <h2>Create new Collection</h2>
          <button
            type="button"
            className={modalCSS.close}
            onClick={onCancelModal}
            aria-label="Close"
          />
        </div>

        <form method="post" onSubmit={onSaveNewCollection}>
          <div className={css.fields}>
            <label htmlFor="collectionName">Collection Name</label>
            <input
              ref={input}
              name="collectionName"
              id="collectionName"
              type="text" />
          </div>

          <div className={css.footer}>
            <button type="button" onClick={onCancelModal}>Cancel</button>
            <button type="submit">Create</button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export const mapStateToProps = () => ({});
const ConnectedNewCollectionModal = connect(mapStateToProps, {
  createHeartList
})(NewCollectionModal);

export default ConnectedNewCollectionModal;
